module.exports = __webpack_public_path__ + "img/logoMonOrientest.3eaee510.svg";